import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../App";
import { toast } from "sonner";
import { ArrowLeft, Inbox } from "lucide-react";

/**
 * Reviews Inbox — "reviews waiting on you". Lists every review instance where
 * the current user is a reviewer voice (self / manager / peer / downstream).
 */
export default function ReviewsInbox() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/reviews/my-inbox");
        setRows(res.data || []);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Couldn't load inbox");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="dm-page-container" style={{ padding: 24, maxWidth: 800, margin: "0 auto" }}>
      <button onClick={() => navigate(-1)} style={{ display: "flex", alignItems: "center", gap: 6, color: "var(--t3)", fontSize: 13, marginBottom: 16, background: "none", border: "none", cursor: "pointer" }}>
        <ArrowLeft size={16} /> BACK
      </button>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 4, display: "flex", alignItems: "center", gap: 8 }}>
        <Inbox size={24} /> Reviews waiting on you
      </h1>
      <p style={{ color: "var(--t3)", fontSize: 13, marginBottom: 24 }}>Rate the people you work with — their shipped work on Hook · Craft · Fit, plus the twice-yearly 360 (Originality · Collaboration · Reliability · Growth).</p>

      {loading ? (
        <p style={{ color: "var(--t3)" }}>Loading…</p>
      ) : rows.length === 0 ? (
        <p style={{ color: "var(--t3)" }}>Nothing in your inbox right now.</p>
      ) : (
        <div style={{ display: "grid", gap: 12 }}>
          {rows.map((r) => (
            <div key={r.instance_id} onClick={() => navigate(`/reviews/instance/${r.instance_id}`)}
              style={{ background: "var(--s1)", border: "1px solid var(--bdr)", borderRadius: 12, padding: 16, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontWeight: 700 }}>{r.subject_name || r.subject_id}</div>
                <div style={{ fontSize: 12, color: "var(--t3)", marginTop: 2 }}>
                  {(r.crafts || []).join(", ")} · you are the <b style={{ textTransform: "capitalize" }}>{r.my_voice}</b> voice
                </div>
              </div>
              <span style={{ fontSize: 12, color: r.my_status === "submitted" ? "#16a34a" : "#d97706", fontWeight: 600 }}>
                {r.my_status === "submitted" ? "✓ done" : "pending"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
